function closeTagEmbedTagObserver(element, callback) {
  if (!element) return;
  // @ts-ignore
  const MutationObserver = window.MutationObserver || window.WebKitMutationObserver;
  const observer = new MutationObserver(function (mutations) {
    // eslint-disable-next-line no-restricted-syntax
    for (const mutation of mutations) {
      if (mutation.type === 'childList') {
        let tagPreviewRemoved = false;
        mutation.removedNodes.forEach((node) => {
          const hasTagPreview = node.classList.contains('tag-preview');

          if (hasTagPreview) {
            tagPreviewRemoved = hasTagPreview;
            return false;
          }
        });

        if (tagPreviewRemoved) {
          callback();
          observer.disconnect();
          break;
        }
      }
    }
  });
  observer.observe(element, {
    childList: true,
    subtree: true,
  });
}

export { closeTagEmbedTagObserver };
